import React from 'react';

import photos from '../../../assets/img/llc/partners';
import defaultLogo from '../../../assets/img/llc/llc_partner.svg'

export default class PartnerCard extends React.PureComponent {
    render() {
        const partner = this.props.partner;

        return (
          <div className="col-6 partnersCards_item_col">
              <div className={'partnersCards_item' + (partner.photo ? " hasPhoto" : "")}>
                  <div className="partnersCards_item_img">
                      <img src={partner.photo ? photos[partner.photo] : defaultLogo}/>
                  </div>
                  <div className="partnersCards_item_text">
                      <div className="partnersCards_item_title">{partner.title}</div>
                      <div className="partnersCards_item_name">{partner.name}</div>
                      <div className="partnersCards_item_desc">
                          {partner.desc &&
                          <div dangerouslySetInnerHTML={{__html: partner.desc}}/>
                          }

                          {partner.tel &&
                          <React.Fragment>
                              <strong>tel.</strong> {partner.tel} <br/>
                          </React.Fragment>
                          }

                          {partner.web &&
                          <React.Fragment>
                              <a href={partner.web} target="_blank">{partner.web}</a> < br/>
                          </React.Fragment>
                          }

                          {partner.email &&
                          <React.Fragment>
                              <strong>E-mail</strong> <a href={`mailto:${partner.email}`}>{partner.email}</a>
                          </React.Fragment>
                          }

                      </div>
                  </div>
              </div>
          </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Partners/PartnerCard/PartnerCard.js